// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__mQF6i","links":"footer_links__AOq_Z","logo":"footer_logo__z_NFK","copyright":"footer_copyright__dtYhr"};